import { render } from "./DashboardComponentUsb.vue?vue&type=template&id=1651b74a"
import script from "./DashboardComponentUsb.vue?vue&type=script&lang=js"
export * from "./DashboardComponentUsb.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__